module.exports = __webpack_public_path__ + "img/distribute05.7cc2df8b.png";